import { Box, Button, Stack, TextField, Typography } from '@mui/material';
import { Field, useFormikContext } from 'formik';
import React from 'react';
import { useSelector } from 'react-redux';

export default function AddCourseStepTwo({ onBack }) {
  const { values, setFieldValue, errors, touched, handleChange, handleSubmit } = useFormikContext();
  const submitLoading = useSelector((state) => state.course.submitLoading);

  return (
    <Stack spacing={3}>
      <TextField fullWidth label="Title" disabled value={values?.title} />

      <Field
        as={TextField}
        fullWidth
        label="Description"
        multiline
        rows={3}
        name="description"
        error={touched.description && Boolean(errors.description)}
        helperText={touched.description && errors.description}
      />

      {/* Course Highlights */}
      <Box>
        <Typography fontWeight={600} mb={1}>
          Course Highlights
        </Typography>

        <Stack spacing={1.5}>
          {values.highlights.map((value, index) => (
            <Stack key={index} direction="row" spacing={1} alignItems="center">
              <TextField
                fullWidth
                placeholder="Highlights"
                value={value}
                onChange={(e) => {
                  const updated = [...values.highlights];
                  updated[index] = e.target.value;
                  setFieldValue('highlights', updated);
                }}
                error={Boolean(errors.highlights?.[index])}
                helperText={errors.highlights?.[index]}
              />

              <Button
                size="small"
                color="error"
                variant="outlined"
                onClick={() =>
                  setFieldValue(
                    'highlights',
                    values.highlights.filter((_, i) => i !== index),
                  )
                }
                disabled={values.highlights.length <= 1}
              >
                Delete
              </Button>
            </Stack>
          ))}
          <Button
            size="small"
            color="success"
            variant="outlined"
            onClick={() => setFieldValue('highlights', [...values.highlights, ''])}
            sx={{ alignSelf: 'flex-start' }}
          >
            + Add Highlight
          </Button>
        </Stack>
      </Box>
      {/* Course Details */}
      <Box>
        <Typography fontWeight={600} mb={1}>
          Course Details
        </Typography>

        <Stack spacing={2}>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1}>
            <TextField fullWidth label="Age Group" value={`${values.ageFrom} – ${values.ageTo} yrs`} disabled />

            <TextField fullWidth label="Duration" name="duration" value={values.duration} disabled />

            <TextField fullWidth label="Lesson" name="lessons" value={values.lessons} disabled />
          </Stack>

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1}>
            <TextField
              fullWidth
              label="Focus Area"
              placeholder="Type The Focus area"
              name="focusArea"
              value={values.focusArea}
              onChange={handleChange}
              error={touched.focusArea && Boolean(errors.focusArea)}
              helperText={touched.focusArea && errors.focusArea}
            />
            <TextField
              fullWidth
              label="Min Session Per Week"
              placeholder="Type The Focus area"
              type="number"
              name="minSessionPerWeek"
              value={values.minSessionPerWeek}
              onChange={handleChange}
              error={touched.minSessionPerWeek && Boolean(errors.minSessionPerWeek)}
              helperText={touched.minSessionPerWeek && errors.minSessionPerWeek}
            />
          </Stack>
        </Stack>
      </Box>

      {/* Why Choose this Course */}
      <Box>
        <Typography fontWeight={600} mb={1}>
          Why Choose this Course
        </Typography>

        <Stack spacing={1.5}>
          {values.reasons.map((value, index) => (
            <Stack key={index} direction="row" spacing={1} alignItems="center">
              <TextField
                fullWidth
                placeholder="Type here..."
                value={value}
                onChange={(e) => {
                  const updated = [...values.reasons];
                  updated[index] = e.target.value;
                  setFieldValue('reasons', updated);
                }}
                error={Boolean(errors.reasons?.[index])}
                helperText={errors.reasons?.[index]}
              />

              <Button
                size="small"
                color="error"
                variant="outlined"
                onClick={() =>
                  setFieldValue(
                    'reasons',
                    values.reasons.filter((_, i) => i !== index),
                  )
                }
                disabled={values.reasons.length <= 1}
              >
                Delete
              </Button>
            </Stack>
          ))}
          <Button
            size="small"
            color="success"
            variant="outlined"
            onClick={() => setFieldValue('reasons', [...values.reasons, ''])}
            sx={{ alignSelf: 'flex-start' }}
          >
            + Add Reason
          </Button>
        </Stack>
      </Box>

      <Box display="flex" justifyContent="space-between">
        <Button size="small" onClick={onBack}>
          Back
        </Button>

        <Button variant="contained" size="small" onClick={handleSubmit} disabled={submitLoading}>
          {submitLoading ? 'saving...' : 'save'}
        </Button>
      </Box>
    </Stack>
  );
}
